




































































































































import {
  useRouter, defineComponent, computed, useContext, PropType, toRefs, ref,
} from '@nuxtjs/composition-api';
import {
  SfProductCardHorizontal, SfButton, SfProperty, SfAddToCart, SfLink
} from '@storefront-ui/vue';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import { useImage } from '~/composables';
import type { Product } from '~/modules/catalog/product/types';
import { useUser } from '~/modules/customer/composables/useUser';
import CategoryProductPrice from '~/modules/catalog/category/components/views/CategoryProductPrice.vue';
import { useProductsWithCommonProductCardProps } from './useProductsWithCommonCardProps';
import { useCart } from '~/modules/checkout/composables/useCart';
import ProductStatusInfo from '~/components/ProductDetailPage/ProductStatusInfo.vue';
import AddToWishlist from '~/components/AddToWishlist.vue';
/* import AddToCompare from '~/components/AddToCompare.vue'; */
import useWishlist from '~/modules/wishlist/composables/useWishlist';
/* import useComparelist from '~/modules/comparelist/composables/useComparelist'; */
import HTMLContent from '~/components/HTMLContent.vue';
import AmLabels from '~/components/AmLabels.vue';

export default defineComponent({
  components: {
    CategoryProductPrice,
    SfProductCardHorizontal,
    SfButton,
    SfProperty,
    SkeletonLoader,
    SfAddToCart,
    ProductStatusInfo,
    AddToWishlist,
    HTMLContent,
    SfLink,
    AmLabels
    /* AddToCompare */
  },
  props: {
    products: {
      type: Array as PropType<Product[]>,
      required: true,
    },
    eventcall : {
      type: Boolean,
      default: false
    },
    pricesLoaded: Boolean,
    loading: Boolean,
  },
  emits: ['click:wishlist', 'click:comparelist', 'click:add-to-cart', 'product-clicked'],
  setup(props, {emit}) {
    const context = useContext();
    const qty = ref([]);
    const { products } = toRefs(props);
    const { productsWithCommonProductCardProps } = useProductsWithCommonProductCardProps(products);
    const { addItem, addedtocart_id: addedtocart_id, error: cartError, loading: isCartLoading, canAddToCart } = useCart();
    const { addOrRemoveItem, isInWishlist } = useWishlist();
    const router = useRouter();
    const category_view_type = "product-list-view";
    /* const { addOrRemoveItemToCompare, isInComparelist } = useComparelist(); */
    const productsFormatted = computed(() => productsWithCommonProductCardProps.value.map((product) => {
      const label = product.commonProps.isInWishlist
        ? 'Remove from Wishlist'
        : 'Save for later';

      /* const comparelabel = product.commonProps.isInComparelist
        ? 'Remove from Comare'
        : 'Add to Comare'; */

      return {
        ...product,
        wishlistMessage: context.i18n.t(label),
        /* comparelistMessage: context.i18n.t(comparelabel), */
      };
    }));

    const handleLinkClick = (event,url) => {
      if(event.target.tagName === 'BUTTON' || event.target.tagName === 'SPAN'){

      }else{
        if(process.client){
          //@ts-ignore
          window.dataLayer = window.dataLayer || [];
          //@ts-ignore
          window.dataLayer.push({
            event: "klevu_click"
          });
        }
        router.push(url);
      }
    }
    const { imageSizes: { productCardHorizontal: imageSize } } = useImage();

    const { isAuthenticated } = useUser();
    const addToCart = (product, qty) => {
      if (!qty) {
        qty = 1;
      }
      // @ts-ignore
      addItem({ product, quantity: parseInt(qty) });
    };
    const savingPrice = (regularPrice, specialPrice) => {
      var regularPriceNum = regularPrice.replace(/\$/g, '');
      regularPriceNum = regularPriceNum.replace(/,/g, '');
      var specialPriceNum = specialPrice.replace(/\$/g, '');
      specialPriceNum = specialPriceNum.replace(/,/g, '');
      var saving = regularPriceNum - specialPriceNum;
      return Intl.NumberFormat('en-EN', { style: 'currency', currency: 'USD', }).format(saving)
    };

    const string_to_json = (message) => {
      const obj = JSON.parse(message);
      return obj;
    };

    const onProductClick = (product) => {
      if (props.eventcall) {
        emit('product-clicked', {
          product
        })
      }
    }

    return {
      handleLinkClick,
      productsFormatted,
      imageSize,
      isAuthenticated,
      qty,
      addToCart,
      addItem,
      canAddToCart,
      isCartLoading,
      addItemToWishlist: addOrRemoveItem,
      /* addItemToComparelist: addOrRemoveItemToCompare, */
      savingPrice,
      addedtocart_id,
      category_view_type,
      string_to_json,
      onProductClick
    };
  },
});
